module.exports = __webpack_public_path__ + "media/svg/white-right-arrow-f343c3cb.svg";